import React, { Fragment, useEffect, useState, useContext } from "react";
import styled, { css } from "styled-components";
import { Context } from "../context";
import { Link, withRouter } from "react-router-dom";
import { getMetadataCategories } from "./utils";
import { MetadataAdd } from "./MetadataAdd";

import uniqid from "uniqid";

import { MetadataSection } from "./MetadataSection";
import { HIGHTLIGHTS_ID } from '../config';

export function MetadataInner(props) {
  const { videoId, history, match, location,
    frame,
    handleFrame
  } = { ...props };
  const context = useContext(Context);


  // const [frame, setFrame] = useState(0);


  return (
    <>
      {/* <MetadataSection
        key={`metadata_${HIGHTLIGHTS_ID}`}
        // key={`metadata_${uniqid()}`}
        typeRef={HIGHTLIGHTS_ID}
        // frame={frame}
        // handleFrame={(n) => {
        //   setFrame(Math.floor(n));
        // }}
        {...props}
      /> */}

      {Boolean(getMetadataCategories(context, videoId, true, false, true).length) &&
        getMetadataCategories(context, videoId, true, false, true)
        // .filter((one) => one !== HIGHTLIGHTS_ID)
        .map((typeRef) => {
          // debugger
          return (<>
              {typeRef && <MetadataSection
                key={`metadata_${typeRef['id']}`}
                // key={`metadata_${uniqid()}`}
                typeRef={typeRef}
                // frame={frame}
                // handleFrame={(n) => {
                //   setFrame(Math.floor(n));
                // }}
                {...props}
              />}
              </>
          );
        })}

      {/* <MetadataAdd
        videoId={videoId}
        categoriesArray={getMetadataCategories(context, videoId)}
      /> */}
    </>
  );
}










export const Metadata = withRouter(MetadataInner);

const CSSscrubber = styled.div`
  height: 32px;
  width: 10px;
  margin-top: -6px;
  background: white;
`;
